<template>
  <div>
    <Head :title="`${form.id}`"/>
    <h1 class="mb-8 text-3xl font-bold">
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/view`">
        {{ data.applicant_name }}
      </Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/treatments/${data.treatment_id}/view`">{{data.treatment_type_name}}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      <Link class="text-gray-400 hover:text-gray-600" :href="`/applicants/${data.applicant_id}/treatments/${data.treatment_id}/treatment-logements/${data.id}/view`">{{ $t('interventions.logements') }}</Link>
      <span class="text-gray-400 font-medium">/ </span>
      {{$t('global.update')}}
    </h1>
    <trashed-message v-if="data.deleted_at" class="mb-6" @restore="restore">
      {{ $t('treatmentlogements.trashed_message') }}
    </trashed-message>
    <div class="max-w-3xl bg-white rounded-md shadow overflow-hidden">
      <form @submit.prevent="update">
        <Form :form-data="form" :statuses="statuses" :status_actuals="status_actuals" :types="types"></Form>
        <div class="flex items-center px-8 py-4 bg-gray-50 border-t border-gray-100">
          <button v-if="!data.deleted_at" class="text-red-600 hover:underline" tabindex="-1" type="button"
                  @click="destroy"
          >{{ $t('global.delete') }}
          </button>
          <loading-button :loading="form.processing" class="btn-indigo ml-auto" type="submit">
            {{ $t('global.update') }}
          </loading-button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue3'
import Layout from '@/Shared/Layout'
import LoadingButton from '@/Shared/LoadingButton'
import TrashedMessage from '@/Shared/TrashedMessage'
import Form from './Form'

export default {
  components: {
    Form,
    Head,
    Link,
    LoadingButton,
    TrashedMessage,
  },
  layout: Layout,
  props: {
    data: Object,
    statuses: Object,
    status_actuals: Array,
    types: Array
  },
  remember: 'form',
  data() {
    return {
      form: this.$inertia.form({
        'id': this.data.id,
        'treatment_id': this.data.treatment_id,
        'status': this.data.status.value,
        'status_actual': this.data.status_actual,
        'type': this.data.type,
        'date_start': this.data.date_start,
        'date_end': this.data.date_end,
        'notes': this.data.notes,
        'created_at': this.data.created_at,
        'updated_at': this.data.updated_at,

      }),
    }
  },
  methods: {
    update() {
      this.form.put(`/applicants/${this.data.applicant_id}/treatments/${this.data.treatment_id}/treatment-logements/${this.data.id}`)
    },
    destroy() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.delete(`/applicants/${this.data.applicant_id}/treatments/${this.data.treatment_id}/treatment-logements/${this.data.id}`)
        }
      })
    },
    restore() {
      this.$swal().then(result => {
        if (result.value) {
          this.$inertia.put(`/treatment-logements/${this.data.id}/restore`)
        }
      })
    },
  },
}
</script>
